import { awardConfiguration } from './Award/configurations/Award.configuration.js';
import { awardsConfiguration } from './Awards/configurations/Awards.configuration.js';
import { changeIndicatorConfiguration } from './ChangeIndicator/configurations/ChangeIndicator.configuration.js';
import { commentaryConfiguration } from './Commentary/configurations/Commentary.configuration.js';
import { disclaimerConfiguration } from './Disclaimer/configurations/Disclaimer.configuration.js';
import { disclaimersConfiguration } from './Disclaimers/configurations/Disclaimers.configuration.js';
import { IOverviewConfiguration } from './IOverviewConfiguration.js';
/* [Component: import] */
/* [ChartComponent: import] */

export const overviewConfiguration: IOverviewConfiguration = {
	commentary: commentaryConfiguration,
	disclaimer: disclaimerConfiguration,
	disclaimers: disclaimersConfiguration,
	changeIndicator: changeIndicatorConfiguration,
	award: awardConfiguration,
	awards: awardsConfiguration,
	/* [Component: interface] */
	/* [ChartComponent: interface] */
};
